import { msalInstance, setupMsalClient } from "./msalClient";

let hasBootstrapped = false;

export const bootstrapMsal = async () => {
  if (hasBootstrapped) {
    return;
  }

  await msalInstance.initialize();
  setupMsalClient();
  hasBootstrapped = true;
};

